export const formatWon = (value) => `${Number(value || 0).toLocaleString()}원`;
